import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class PNLOriginalTransactionsUseCase extends BaseUseCase {
    constructor(pnlReportRepo) {
        super();
        this.pnlReportRepo = pnlReportRepo;
    }
    async fetchResult(requestData) {
        return await this.pnlReportRepo.getOriginalTxns(requestData);
    }
}
export default PNLOriginalTransactionsUseCase;
